
"use client";
import React, { useEffect, useState } from 'react';
import signup from "./signup.module.css";
import { useAuthStore } from '../store/authstore';
import { useRouter } from 'next/navigation';
import validator from '../utils/validator';
import deviceInfo from '../utils/deviceInfo';
import tohash from '../utils/tohash';
import { fetchWithLoader } from '../utils/api';
import { useToastStore } from '../store/localapi';
import Link from 'next/link';

export default function Signup() {
  const user = useAuthStore((state) => state.user);
  // const login = useAuthStore((state) => state.login);
  const { showToast } = useToastStore()
  const router = useRouter();
  const validate = validator();


  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmPassword] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [displayDob, setDisplayDob] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [showPassword, setShowPassword] = useState({
    password: true,
    confirmpassword: true,
  });

  const [errors, setErrors] = useState({
    username: '',
    email: '',
    password: '',
    confirmpassword: '',
    termsAccepted: '',
    ageConfirmed: '',
    dob: ''
  });
  const emailError = validate.email(email);
  const usernameError = validate.username(username);
  const passwordError = validate.password(password);
  const doberror = validate.dob(dob);

  // Convert yyyy-mm-dd to dd/mm/yyyy for display
  const formatDateForDisplay = (dateStr: string) => {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };


  const [isClient, setIsClient] = useState(false);

  useEffect(() => setIsClient(true), []);
  useEffect(() => {
    // eslint-disable-next-line
    isClient && setTimeout(() => user && router.push('/'), 50);
  }, [user, isClient, router]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const newErrors = {
      username: usernameError ?? '',
      email: emailError ?? '',
      password: passwordError ?? '',
      confirmpassword: confirmpassword ? '' : 'Confirm Password is required',
      termsAccepted: termsAccepted ? '' : 'accept the terms',
      ageConfirmed: ageConfirmed ? '' : 'confirm minimum age',
      dob: doberror ?? ''
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    const device = deviceInfo();
    let deviceId: string | null = "";
    if (device.name && email) {
      deviceId = tohash(`${device.name}${device.platform}${device.os}${email}${device.version}`);
    }

    if (!deviceId) {
      console.error("Device ID could not be generated");
      return;
    }


    const userdata = {
      user_name: username,
      user_email: email,
      user_password: password,
      a_id: 0,
      login_type: "Manual",
      device_id: deviceId,
      apple_socail_id: "id",
      device_name: device.name,
      fcm_id: "",
      user_image: "",
      user_dob: dob,
      user_gender: gender,
      app_ver: device.version,
      user_cc: "US",
      dev_cc: "US",
      dev_make: device.os,
      dev_model: device.platform,
      app_usage_counter: "5000",
      dev_lang: "eng"
    }

    fetchWithLoader('drama_user_registration_json_v2.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userdata)
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json();
          // console.log('first', data.data.ErrorMessage == "Successfully Register" && data?.data?.Data?.otp !== "", data.data.ErrorMessage == "Email Id already Exists")
          // console.log('signup', data)
        if (data.data.ErrorCode == 0 && data?.data?.Data?.otp !== "") {
          const hash = tohash(data?.data?.Data?.otp.toString());
          const final = `${hash?.slice(0, 5)}${data?.data?.Data?.otp}${hash?.slice(5)}`;
          sessionStorage.setItem('_hash', `${final}`);
          localStorage.setItem('_id', data.data.Data.user_id);
          router.push(`/verifyotp?signup=${email}`);
          return;
        }
        else if (data.data.ErrorCode == -1) {
          // if (data.data.Data.user_email_auth == "0") {
          //   fetch('https://dramasstory.com/web/drama_otp_resend.php', {
          //     method: 'POST',
          //     headers: { 'Content-Type': 'application/json' },
          //     body: JSON.stringify({ user_email: data.data.Data.user_email })
          //   }).then(res => res.json()).then(d => {
          //     if (d?.data?.Data?.otp !== "") {
          //       const hash = tohash(d?.data?.Data?.otp.toString());
          //       const final = `${hash?.slice(0, 5)}${d?.data?.Data?.otp}${hash?.slice(5)}`;
          //       sessionStorage.setItem('_hash', `${final}`);
          //       localStorage.setItem('_id', d.data.Data.user_id);
          //       router.replace(`/verifyotp/?emailauth=${data.data.Data.user_email}`);
          //       return;
          //     } else {
          //       router.replace('/signup');
          //     }
          //   })
          //   return
          // }
          // login(data.data.Data)
          // router.push(`/login`);
          showToast("Account Already Exists", "info")
          return;
        }
      } else {
        console.error("Registration failed");
      }
    });

  };

  return (
  
    <div className={`${signup.signupfrm} signUpSec`}>
      <div className="container">
        <div className="signupForm">

          <form onSubmit={handleSubmit}>
            <h2>Create Your Account</h2>

            <div className="field">
              <div className="name">
                <input
                  type="text"
                  onChange={(e) => setUsername(e.target.value)}
                  onBlur={() => setErrors((prev) => ({
                    ...prev,
                    username: validate.username(username) ?? ''
                  }))}
                  name="name"
                  id="name"
                  placeholder="Username*"
                  autoComplete="username"
                  required
                />

                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <mask id="mask0_2591_545" mask-type="luminance" maskUnits="userSpaceOnUse" x="1" y="0" width="20" height="21">
                      <path d="M1.05469 0.439819H20.1735V19.5586H1.05469V0.439819Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_2591_545)">
                      <path fillRule="evenodd" clipRule="evenodd" d="M7.17872 18.0649C5.52885 18.0649 4.19141 16.7275 4.19141 15.0776V4.92078C4.19141 3.27092 5.52885 1.93347 7.17872 1.93347H14.0495C15.6994 1.93347 17.0368 3.27092 17.0368 4.92078V15.0776C17.0368 16.7275 15.6994 18.0649 14.0495 18.0649H7.17872ZM2.69775 15.0776C2.69775 17.5524 4.70393 19.5586 7.17872 19.5586H14.0495C16.5243 19.5586 18.5305 17.5524 18.5305 15.0776V4.92078C18.5305 2.446 16.5243 0.439819 14.0495 0.439819H7.17872C4.70393 0.439819 2.69775 2.446 2.69775 4.92078V15.0776Z" fill="#9B9D9C" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M7.62671 15.334C8.03917 15.334 8.37354 14.9996 8.37354 14.5872C8.37354 13.506 9.26149 12.6122 10.3608 12.6122H10.8672C11.9665 12.6122 12.8545 13.506 12.8545 14.5872C12.8545 14.9996 13.1889 15.334 13.6013 15.334C14.0138 15.334 14.3482 14.9996 14.3482 14.5872C14.3482 12.6775 12.7879 11.1186 10.8672 11.1186H10.3608C8.44018 11.1186 6.87988 12.6775 6.87988 14.5872C6.87988 14.9996 7.21425 15.334 7.62671 15.334Z" fill="#9B9D9C" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M8.00049 7.19814C8.00049 8.68301 9.2042 9.88672 10.6891 9.88672C12.1739 9.88672 13.3776 8.68301 13.3776 7.19814C13.3776 5.71327 12.1739 4.50956 10.6891 4.50956C9.2042 4.50956 8.00049 5.71327 8.00049 7.19814ZM10.6891 8.39306C10.0291 8.39306 9.49414 7.85809 9.49414 7.19814C9.49414 6.5382 10.0291 6.00322 10.6891 6.00322C11.349 6.00322 11.884 6.5382 11.884 7.19814C11.884 7.85809 11.349 8.39306 10.6891 8.39306Z" fill="#9B9D9C" />
                    </g>
                  </svg>
                </span>

              </div>

              <p className="error" style={{ opacity: errors.username ? '1' : '0' }}>{errors.username}.</p>
            </div>


            <div className="field">
              <div className="email">
                <input type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={() => setErrors((prev) => ({
                    ...prev,
                    email: validate.email(email) ?? ''
                  }))}
                  name="Email" id="email" placeholder='Email*' autoComplete="email" required />

                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M18.3104 6.379C18.5757 7.36621 18.5757 8.72811 18.5757 10.8299C18.5757 13.8152 18.5757 15.3079 17.8154 16.3542C17.5699 16.6922 17.2727 16.9894 16.9348 17.2349C15.8884 17.9952 14.3957 17.9952 11.4104 17.9952H9.81808C6.83278 17.9952 5.34008 17.9952 4.29371 17.2349C3.95575 16.9894 3.65855 16.6922 3.41301 16.3542C2.65278 15.3079 2.65277 13.8152 2.65277 10.8299C2.65277 8.72111 2.65277 7.35713 2.92076 6.36914L4.59481 8.04325C5.89436 9.34278 6.91279 10.3612 7.81419 11.049C8.73684 11.7529 9.60687 12.1665 10.6143 12.1665C11.6218 12.1665 12.4918 11.7529 13.4145 11.049C14.3159 10.3612 15.3343 9.34278 16.6339 8.04324L18.1905 6.48663L18.3104 6.379Z" fill="#9B9D9C" />
                    <path d="M17.7793 5.25635L17.6926 5.32806L17.3686 5.61888L15.8215 7.166C14.4826 8.50484 13.5201 9.4656 12.6898 10.099C11.8734 10.722 11.2555 10.9718 10.6141 10.9718C9.97269 10.9718 9.3548 10.722 8.53836 10.099C7.70814 9.4656 6.7456 8.50484 5.40672 7.166L3.56929 5.32856L3.4693 5.22912C3.71483 4.89118 3.9555 4.66984 4.29347 4.42431C5.33984 3.66406 6.83254 3.66406 9.81784 3.66406H11.4101C14.3955 3.66406 15.8881 3.66406 16.9345 4.42431C17.2725 4.66984 17.5338 4.91841 17.7793 5.25635Z" fill="#9B9D9C" />
                  </svg>
                </span>


              </div>
              <p className="error" style={{ opacity: errors.email ? '1' : '0' }}>{errors.email}.</p>
            </div>

            <div className="field">
              <div className="password">
                <input className="Pswrd" type={showPassword.password ? "password" : "text"}
                  onChange={(e) => setPassword(e.target.value)}
                  onBlur={() => setErrors((prev) => ({
                    ...prev,
                    password: validate.password(password) ?? ''
                  }))}
                  name="Password" id="password" placeholder='Password*' required />

                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M5.32263 8.38487C8.76609 8.50991 12.3768 8.18006 15.8014 8.37221C16.8155 8.42898 17.6076 8.88041 17.9731 9.72881C18.0981 10.0188 18.1556 10.3333 18.1556 10.6489L18.1541 18.2113C18.1541 18.846 17.8983 19.4601 17.4284 19.8874C17.0829 20.2015 16.6395 20.409 16.1462 20.4577L5.00543 20.4558C4.00247 20.3039 3.20009 19.4946 3.07275 18.4863L3.07659 10.6957C3.07697 9.60339 3.83601 8.64069 4.90763 8.42936C5.04225 8.4029 5.1811 8.38794 5.32263 8.38525V8.38487ZM11.6714 12.6311C10.3018 11.2634 8.22721 13.3161 9.52129 14.6831C9.61104 14.7778 9.86878 14.9155 9.88604 15.0068C9.92362 15.5625 9.83541 16.1812 9.88412 16.7293C9.96466 17.6325 11.2591 17.6551 11.342 16.7293C11.3922 16.1697 11.2963 15.5426 11.3466 14.9753C12.18 14.479 12.371 13.3299 11.6711 12.6311H11.6714Z" fill="#9B9D9C" />
                    <path d="M11.6714 12.6286C12.3714 13.3275 12.18 14.4766 11.3469 14.9729C11.2963 15.5401 11.3922 16.1672 11.3423 16.7268C11.2595 17.6527 9.96502 17.6301 9.88448 16.7268C9.83577 16.1791 9.92398 15.5605 9.88639 15.0043C9.86875 14.913 9.61101 14.7753 9.52164 14.6806C8.22756 13.3136 10.3018 11.2609 11.6714 12.6286Z" fill="#1F222B" />
                    <path d="M14.6314 2.65765C13.864 1.6915 12.5388 0.981563 11.3019 0.878773C10.9364 0.848473 10.2882 0.846938 9.9238 0.878773C8.53575 1.00036 7.17072 1.81922 6.39366 2.95413C5.4417 4.3441 5.13215 6.82118 5.20502 8.47272L7.42638 8.47904C7.35389 6.91226 7.71842 4.06679 9.38952 3.38447C10.2567 3.03046 11.537 3.08454 12.3175 3.6307C13.5744 4.51017 13.6568 6.2902 13.5989 7.68439L13.5552 8.54544L15.8653 8.37515L15.896 7.68439C15.9804 5.91816 15.7602 4.0783 14.6314 2.65765Z" fill="#9B9D9C" />
                  </svg>
                </span>


                {password && (
                  <>
                    {showPassword.password && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({ ...prev, password: false }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M17.664 0.484375L14.3328 3.81558C9.82084 0.613975 4.56004 2.48597 0.936035 9.48438C1.90564 11.3564 2.99524 12.854 4.15204 13.9964L0.936035 17.2124L2.20804 18.4844L18.936 1.75637L17.664 0.484375ZM9.03843 8.58197C8.53924 8.58197 8.13604 8.17877 8.13604 7.67957C8.13604 7.18037 8.53924 6.77718 9.03843 6.77718C9.53764 6.77718 9.94084 7.18037 9.94084 7.67957C9.94084 8.17877 9.53284 8.58197 9.03843 8.58197ZM11.76 6.38838C11.2272 6.07158 10.6032 5.88438 9.93604 5.88438C7.94884 5.88438 6.33604 7.49718 6.33604 9.48438C6.33604 10.1516 6.51844 10.7756 6.84004 11.3084L5.35683 12.7916C4.42564 11.9324 3.53764 10.8284 2.73604 9.48438C4.79044 6.03797 7.38244 4.08438 9.93604 4.08438C10.992 4.08438 12.0528 4.42998 13.08 5.06838L11.76 6.38838Z" fill="#9B9D9C" />
                        <path d="M16.9918 6.40234L15.811 7.58314C16.2718 8.15914 16.7182 8.78314 17.1358 9.48394C15.0814 12.9303 12.4894 14.8839 9.93581 14.8839C9.51821 14.8839 9.10061 14.8119 8.68301 14.7111L7.26221 16.1319C11.3422 17.8167 15.7678 15.6039 18.9358 9.48394C18.331 8.31274 17.6782 7.29034 16.9918 6.40234Z" fill="#9B9D9C" />
                      </svg>
                    </span>}
                    {!showPassword.password && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({ ...prev, password: true }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M5.53924 3.34415C7.67955 1.85471 10.0464 1.35887 12.6096 2.36975C16.5452 3.92159 18.936 9.01295 18.936 9.01295C18.6116 9.71471 17.1298 12.251 15.72 13.525C14.4111 14.7077 12.6096 15.661 12.6096 15.661C10.8284 16.369 8.68756 16.571 6.14452 15.0989C2.73556 12.9936 0.936035 9.01295 0.936035 9.01295C1.2778 8.25215 3.049 5.01119 5.53924 3.34415ZM6.925 13.5624C8.94436 14.6674 10.6445 14.5157 12.0591 13.9843C12.0591 13.9843 13.4895 13.2691 14.5292 12.3816C15.6485 11.4254 16.8255 9.52223 17.0832 8.99567C17.0832 8.99567 15.1848 5.17487 12.0596 4.01039C10.0239 3.25199 8.14467 3.62399 6.44499 4.74191C4.46739 5.99279 3.061 8.42495 2.78979 8.99567C2.78979 8.99567 4.21875 11.9827 6.92595 13.5624H6.925Z" fill="white" />
                        <path d="M9.93577 5.44336C11.9124 5.44336 13.5146 7.0456 13.5146 9.02224C13.5146 10.9989 11.9124 12.6011 9.93577 12.6011C7.95913 12.6011 6.35689 10.9989 6.35689 9.02224C6.35689 7.0456 7.95913 5.44336 9.93577 5.44336ZM10.843 8.10976C11.3407 8.10976 11.7444 7.70608 11.7444 7.20832C11.7444 6.71056 11.3407 6.30688 10.843 6.30688C10.3452 6.30688 9.94153 6.71056 9.94153 7.20832C9.94153 7.70608 10.3452 8.10976 10.843 8.10976Z" fill="white" />
                      </svg>
                    </span>}
                  </>
                )}
              </div>
              <p className="error" style={{ opacity: errors.password ? '1' : '0' }}>{errors.password}.</p>
            </div>


            <div className="field">
              <div className="password">
                <input className="Pswrd" type={showPassword.confirmpassword ? "password" : "text"}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  onBlur={() => setErrors((prev) => ({
                    ...prev,
                    confirmpassword:
                      confirmpassword !== password
                        ? "Passwords do not match"
                        : "",
                  }))}
                  name="Password" id="confirmpassword" placeholder='Confirm Password*' required />

                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M5.32263 8.38487C8.76609 8.50991 12.3768 8.18006 15.8014 8.37221C16.8155 8.42898 17.6076 8.88041 17.9731 9.72881C18.0981 10.0188 18.1556 10.3333 18.1556 10.6489L18.1541 18.2113C18.1541 18.846 17.8983 19.4601 17.4284 19.8874C17.0829 20.2015 16.6395 20.409 16.1462 20.4577L5.00543 20.4558C4.00247 20.3039 3.20009 19.4946 3.07275 18.4863L3.07659 10.6957C3.07697 9.60339 3.83601 8.64069 4.90763 8.42936C5.04225 8.4029 5.1811 8.38794 5.32263 8.38525V8.38487ZM11.6714 12.6311C10.3018 11.2634 8.22721 13.3161 9.52129 14.6831C9.61104 14.7778 9.86878 14.9155 9.88604 15.0068C9.92362 15.5625 9.83541 16.1812 9.88412 16.7293C9.96466 17.6325 11.2591 17.6551 11.342 16.7293C11.3922 16.1697 11.2963 15.5426 11.3466 14.9753C12.18 14.479 12.371 13.3299 11.6711 12.6311H11.6714Z" fill="#9B9D9C" />
                    <path d="M11.6714 12.6286C12.3714 13.3275 12.18 14.4766 11.3469 14.9729C11.2963 15.5401 11.3922 16.1672 11.3423 16.7268C11.2595 17.6527 9.96502 17.6301 9.88448 16.7268C9.83577 16.1791 9.92398 15.5605 9.88639 15.0043C9.86875 14.913 9.61101 14.7753 9.52164 14.6806C8.22756 13.3136 10.3018 11.2609 11.6714 12.6286Z" fill="#1F222B" />
                    <path d="M14.6314 2.65765C13.864 1.6915 12.5388 0.981563 11.3019 0.878773C10.9364 0.848473 10.2882 0.846938 9.9238 0.878773C8.53575 1.00036 7.17072 1.81922 6.39366 2.95413C5.4417 4.3441 5.13215 6.82118 5.20502 8.47272L7.42638 8.47904C7.35389 6.91226 7.71842 4.06679 9.38952 3.38447C10.2567 3.03046 11.537 3.08454 12.3175 3.6307C13.5744 4.51017 13.6568 6.2902 13.5989 7.68439L13.5552 8.54544L15.8653 8.37515L15.896 7.68439C15.9804 5.91816 15.7602 4.0783 14.6314 2.65765Z" fill="#9B9D9C" />
                  </svg>
                </span>

                {confirmpassword !== '' && (
                  <>
                    {showPassword.confirmpassword && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({ ...prev, confirmpassword: false }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M17.664 0.484375L14.3328 3.81558C9.82084 0.613975 4.56004 2.48597 0.936035 9.48438C1.90564 11.3564 2.99524 12.854 4.15204 13.9964L0.936035 17.2124L2.20804 18.4844L18.936 1.75637L17.664 0.484375ZM9.03843 8.58197C8.53924 8.58197 8.13604 8.17877 8.13604 7.67957C8.13604 7.18037 8.53924 6.77718 9.03843 6.77718C9.53764 6.77718 9.94084 7.18037 9.94084 7.67957C9.94084 8.17877 9.53284 8.58197 9.03843 8.58197ZM11.76 6.38838C11.2272 6.07158 10.6032 5.88438 9.93604 5.88438C7.94884 5.88438 6.33604 7.49718 6.33604 9.48438C6.33604 10.1516 6.51844 10.7756 6.84004 11.3084L5.35683 12.7916C4.42564 11.9324 3.53764 10.8284 2.73604 9.48438C4.79044 6.03797 7.38244 4.08438 9.93604 4.08438C10.992 4.08438 12.0528 4.42998 13.08 5.06838L11.76 6.38838Z" fill="#9B9D9C" />
                        <path d="M16.9918 6.40234L15.811 7.58314C16.2718 8.15914 16.7182 8.78314 17.1358 9.48394C15.0814 12.9303 12.4894 14.8839 9.93581 14.8839C9.51821 14.8839 9.10061 14.8119 8.68301 14.7111L7.26221 16.1319C11.3422 17.8167 15.7678 15.6039 18.9358 9.48394C18.331 8.31274 17.6782 7.29034 16.9918 6.40234Z" fill="#9B9D9C" />
                      </svg>
                    </span>}
                    {!showPassword.confirmpassword && <span className="showEye"
                      onClick={() => setShowPassword((prev) => ({ ...prev, confirmpassword: true }))}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M5.53924 3.34415C7.67955 1.85471 10.0464 1.35887 12.6096 2.36975C16.5452 3.92159 18.936 9.01295 18.936 9.01295C18.6116 9.71471 17.1298 12.251 15.72 13.525C14.4111 14.7077 12.6096 15.661 12.6096 15.661C10.8284 16.369 8.68756 16.571 6.14452 15.0989C2.73556 12.9936 0.936035 9.01295 0.936035 9.01295C1.2778 8.25215 3.049 5.01119 5.53924 3.34415ZM6.925 13.5624C8.94436 14.6674 10.6445 14.5157 12.0591 13.9843C12.0591 13.9843 13.4895 13.2691 14.5292 12.3816C15.6485 11.4254 16.8255 9.52223 17.0832 8.99567C17.0832 8.99567 15.1848 5.17487 12.0596 4.01039C10.0239 3.25199 8.14467 3.62399 6.44499 4.74191C4.46739 5.99279 3.061 8.42495 2.78979 8.99567C2.78979 8.99567 4.21875 11.9827 6.92595 13.5624H6.925Z" fill="white" />
                        <path d="M9.93577 5.44336C11.9124 5.44336 13.5146 7.0456 13.5146 9.02224C13.5146 10.9989 11.9124 12.6011 9.93577 12.6011C7.95913 12.6011 6.35689 10.9989 6.35689 9.02224C6.35689 7.0456 7.95913 5.44336 9.93577 5.44336ZM10.843 8.10976C11.3407 8.10976 11.7444 7.70608 11.7444 7.20832C11.7444 6.71056 11.3407 6.30688 10.843 6.30688C10.3452 6.30688 9.94153 6.71056 9.94153 7.20832C9.94153 7.70608 10.3452 8.10976 10.843 8.10976Z" fill="white" />
                      </svg>
                    </span>}
                  </>
                )}
              </div>
              <p className="error" style={{ opacity: errors.confirmpassword ? 1 : 0 }}>{errors.confirmpassword}.</p>
            </div>


            <div className="field">
              <div className="gender">
                <select name="gender" onChange={(e) => setGender(e.target.value)}>
                  <option value="" >Select Gender</option>
                  <option value="female">Female</option>
                  <option value="male">Male</option>
                  <option value="other">Other</option>
                </select>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M10.6143 6.40272C10.6143 4.24401 8.86405 2.49414 6.70534 2.49414C4.54664 2.49414 2.79639 4.24401 2.79639 6.40272C2.79639 8.33887 4.20537 9.94215 6.05411 10.2529V14.3321L5.02075 13.2995L4.09963 14.2206L6.70534 16.8267L9.31144 14.2206L8.38994 13.2991L7.35696 14.3317V10.2525C9.20494 9.94177 10.6147 8.33849 10.6147 6.40233L10.6143 6.40272ZM6.70534 9.00881C5.26582 9.00881 4.09963 7.84185 4.09963 6.40272C4.09963 4.96358 5.26582 3.797 6.70534 3.797C8.14486 3.797 9.31144 4.96358 9.31144 6.40272C9.31144 7.84185 8.14448 9.00881 6.70534 9.00881Z" fill="#9B9D9C" />
                    <path d="M15.1748 10.3711V7.05459H17.1293V5.75135H15.1748V3.79688H13.872V5.75135H11.9175V7.05459H13.872V10.3711C12.0236 10.6822 10.6143 12.2855 10.6143 14.2213C10.6143 16.38 12.3637 18.1302 14.5232 18.1302C16.6827 18.1302 18.4322 16.38 18.4322 14.2213C18.4322 12.2855 17.022 10.6822 15.1745 10.3711H15.1748ZM14.5232 16.827C13.0837 16.827 11.9171 15.66 11.9171 14.2209C11.9171 12.7818 13.0833 11.6148 14.5232 11.6148C15.9631 11.6148 17.1293 12.7818 17.1293 14.2209C17.1293 15.66 15.9624 16.827 14.5232 16.827Z" fill="#9B9D9C" />
                  </svg>
                </span>


                {/* <span className="downarrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
                    <path d="M17.2007 1.31662C17.2343 1.63014 17.1066 1.95161 16.9255 2.19506L9.70188 9.62929C9.28922 10.0114 8.62672 10.0476 8.20283 9.65674L0.900566 2.14088C0.158058 1.06595 1.31744 -0.188863 2.41646 0.472134L8.93902 7.16735L15.4307 0.493806C16.1255 -0.00754055 17.108 0.444683 17.2007 1.31662Z" fill="#9B9D9C" />
                  </svg>
                </span> */}


              </div>
              <p className="error">Gender is required</p>
            </div>


            <div className="field">
              <div className="date">
                <input type="date" name="dateofbirth" placeholder="DD/MM/YYYY"
                  value={dob}
                  max={new Date().toISOString().split('T')[0]}
                  onChange={(e) => {
                    setDob(e.target.value);
                    setDisplayDob(formatDateForDisplay(e.target.value));
                  }}
                  onBlur={() => {
                    setErrors((prev) => ({
                      ...prev, dob: validate.dob(dob) ?? ''
                    }))
                  }}
                />
                {!dob ? (
                  <span className="placeHolder">DD/MM/YYYY</span>
                ) : (
                  displayDob && <span className="dateDisplay">{displayDob}</span>
                )}

                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M14.5788 9.34704C14.9157 9.34704 15.1888 9.07392 15.1888 8.737C15.1888 8.40008 14.9157 8.12695 14.5788 8.12695C14.2419 8.12695 13.9688 8.40008 13.9688 8.737C13.9688 9.07392 14.2419 9.34704 14.5788 9.34704Z" fill="#9B9D9C" />
                    <path d="M15.9826 3.55212H15.1896V2.94208C15.1896 2.60503 14.9166 2.33203 14.5795 2.33203C14.2425 2.33203 13.9695 2.60503 13.9695 2.94208V3.55212H11.1938V2.94208C11.1938 2.60503 10.9208 2.33203 10.5837 2.33203C10.2467 2.33203 9.9737 2.60503 9.9737 2.94208V3.55212H7.22849V2.94208C7.22849 2.60503 6.9555 2.33203 6.61845 2.33203C6.2814 2.33203 6.0084 2.60503 6.0084 2.94208V3.55212H5.24584C3.90039 3.55212 2.80566 4.64685 2.80566 5.9923V15.509C2.80566 16.8545 3.90039 17.9492 5.24584 17.9492H9.91269C10.2497 17.9492 10.5227 17.6762 10.5227 17.3391C10.5227 17.0021 10.2497 16.7291 9.91269 16.7291H5.24584C4.57297 16.7291 4.02575 16.1819 4.02575 15.509V5.9923C4.02575 5.31942 4.57297 4.77221 5.24584 4.77221H6.0084V5.38226C6.0084 5.71931 6.2814 5.9923 6.61845 5.9923C6.9555 5.9923 7.22849 5.71931 7.22849 5.38226V4.77221H9.9737V5.38226C9.9737 5.71931 10.2467 5.9923 10.5837 5.9923C10.9208 5.9923 11.1938 5.71931 11.1938 5.38226V4.77221H13.9695V5.38226C13.9695 5.71931 14.2425 5.9923 14.5795 5.9923C14.9166 5.9923 15.1896 5.71931 15.1896 5.38226V4.77221H15.9826C16.6555 4.77221 17.2027 5.31942 17.2027 5.9923V9.46956C17.2027 9.80661 17.4757 10.0796 17.8128 10.0796C18.1498 10.0796 18.4228 9.80661 18.4228 9.46956V5.9923C18.4228 4.64685 17.3281 3.55212 15.9826 3.55212Z" fill="#9B9D9C" />
                    <path d="M14.7318 10.5664C12.6967 10.5664 11.041 12.2221 11.041 14.2572C11.041 16.2923 12.6967 17.948 14.7318 17.948C16.7669 17.948 18.4226 16.2923 18.4226 14.2572C18.4226 12.2221 16.7669 10.5664 14.7318 10.5664ZM14.7318 16.7279C13.3696 16.7279 12.2611 15.6194 12.2611 14.2572C12.2611 12.8949 13.3696 11.7865 14.7318 11.7865C16.094 11.7865 17.2025 12.8949 17.2025 14.2572C17.2025 15.6194 16.094 16.7279 14.7318 16.7279Z" fill="#9B9D9C" />
                    <path d="M15.6157 13.6451H15.3412V13.0046C15.3412 12.6675 15.0682 12.3945 14.7311 12.3945C14.3941 12.3945 14.1211 12.6675 14.1211 13.0046V14.2552C14.1211 14.5922 14.3941 14.8652 14.7311 14.8652H15.6157C15.9528 14.8652 16.2257 14.5922 16.2257 14.2552C16.2257 13.9181 15.9528 13.6451 15.6157 13.6451Z" fill="#9B9D9C" />
                    <path d="M11.9255 9.34704C12.2624 9.34704 12.5355 9.07392 12.5355 8.737C12.5355 8.40008 12.2624 8.12695 11.9255 8.12695C11.5886 8.12695 11.3154 8.40008 11.3154 8.737C11.3154 9.07392 11.5886 9.34704 11.9255 9.34704Z" fill="#9B9D9C" />
                    <path d="M9.27215 11.9994C9.60907 11.9994 9.8822 11.7263 9.8822 11.3893C9.8822 11.0524 9.60907 10.7793 9.27215 10.7793C8.93524 10.7793 8.66211 11.0524 8.66211 11.3893C8.66211 11.7263 8.93524 11.9994 9.27215 11.9994Z" fill="#9B9D9C" />
                    <path d="M6.61835 9.34704C6.95526 9.34704 7.22839 9.07392 7.22839 8.737C7.22839 8.40008 6.95526 8.12695 6.61835 8.12695C6.28143 8.12695 6.0083 8.40008 6.0083 8.737C6.0083 9.07392 6.28143 9.34704 6.61835 9.34704Z" fill="#9B9D9C" />
                    <path d="M6.61835 11.9994C6.95526 11.9994 7.22839 11.7263 7.22839 11.3893C7.22839 11.0524 6.95526 10.7793 6.61835 10.7793C6.28143 10.7793 6.0083 11.0524 6.0083 11.3893C6.0083 11.7263 6.28143 11.9994 6.61835 11.9994Z" fill="#9B9D9C" />
                    <path d="M6.61835 14.6537C6.95526 14.6537 7.22839 14.3806 7.22839 14.0436C7.22839 13.7067 6.95526 13.4336 6.61835 13.4336C6.28143 13.4336 6.0083 13.7067 6.0083 14.0436C6.0083 14.3806 6.28143 14.6537 6.61835 14.6537Z" fill="#9B9D9C" />
                    <path d="M9.27215 14.6537C9.60907 14.6537 9.8822 14.3806 9.8822 14.0436C9.8822 13.7067 9.60907 13.4336 9.27215 13.4336C8.93524 13.4336 8.66211 13.7067 8.66211 14.0436C8.66211 14.3806 8.93524 14.6537 9.27215 14.6537Z" fill="#9B9D9C" />
                    <path d="M9.27215 9.34704C9.60907 9.34704 9.8822 9.07392 9.8822 8.737C9.8822 8.40008 9.60907 8.12695 9.27215 8.12695C8.93524 8.12695 8.66211 8.40008 8.66211 8.737C8.66211 9.07392 8.93524 9.34704 9.27215 9.34704Z" fill="#9B9D9C" />
                  </svg>
                </span>


              </div>
              <p className="error" style={{ opacity: errors.dob ? 1 : 0 }}>{errors.dob}.</p>
            </div>

            <div className="loginBtn field">
              <button type='submit' className="commonBtn">Sign Up</button>
              <p className='error SetSpace' style={{ opacity: errors.termsAccepted || errors.ageConfirmed ? 1 : 0 }}>Please check the box to continue</p>
              {/* <p className='error' style={{ opacity: errors.termsAccepted || errors.ageConfirmed ? 1 : 0 }}>You must {errors.termsAccepted} {errors.ageConfirmed}</p> */}
              <p className='signInAcc'>Already have an account? <Link href="/login">Sign In</Link></p>
            </div>

            <div className="checkTpolicy">
              <label>
                <div className="checkboxed">
                  <input type="checkbox" name="checkbox" onChange={(e) => setTermsAccepted(e.target.checked)} />
                </div>
                <p className="condition">I have read and agree to DramaFlicks <Link target='_blank' href="/terms-of-use">Terms of Use</Link> and <Link target='_blank' href="/privacy-policy">Privacy Policy.</Link> </p>
              </label>

              <label>
                <div className="checkboxed">
                  <input type="checkbox" name="checkbox" onChange={(e) => setAgeConfirmed(e.target.checked)} />
                </div>
                <p className="condition">I m over the minimum age requirement of my country as per <Link target='_blank' href="https://www.globalratings.com/ratingsguide.aspx">IARC.</Link></p>
              </label>

            </div>

          </form>
        </div>
      </div>
    </div>
  

  )
}